import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { selectAccountConfig } from '@selectors'


import useStyles from './resources.style'

import { searchFilter, validateUrl } from '@utils/helpers'

import { IconInline, Input, ResponsiveContainer, Paragraph, Title } from '@omnilert/components'

import { EMPTY_STATE_RESOURCES, PLACEHOLDER_RESOURCES_FILTER } from '../../assets/i18n/strings'
import i18n from 'i18n-js'

const Resources = (props) => {
  const classes = useStyles(props)

  const Analytics = useSelector(state => state.analytic.analytics)
  const accountConfig = useSelector(selectAccountConfig)

  const resources = accountConfig?.resources

  const [searchTerm, setSearchTerm] = useState('')
  const [searchResults, setSearchResults] = useState(resources || [])
  const [url, setUrl] = useState('')

  const filterFormRef = useRef(null)

  const handleChange = (event) => {
    setSearchTerm(event.target.value)
  }

  useEffect(() => {
    if (resources?.length) {
      const results = searchFilter(resources, searchTerm)

      setSearchResults(results)

      if (searchTerm && results.length > 0) {
        Analytics.logEvent('ResourcesFilteredWithResults')
      }

      if (searchTerm && results.length === 0) {
        Analytics.logEvent('ResourcesFilterNoResults')
      }
    }
  }, [Analytics, resources, searchTerm])

  const processResourceLink = (resource, index) => {
    const { type, url } = resource

    Analytics.logEvent(`ResourcesTapped${searchTerm ? 'Filtered' : ''}`, { index, type })

    if (type === 'phone') {
      return setUrl(`tel:${url}`)
    }

    if (url) {
      return setUrl(validateUrl(url))
    }
  }

  const resetSearch = () => {
    setSearchTerm('')
    filterFormRef.current.reset()
    Analytics.logEvent('ResourcesFilterCleared')
  }

  const onFocus = () => {
    Analytics.logEvent('ResourcesFilterTextInputFocus')
  }

  const onScroll = () => {
    Analytics.logEvent('ResourcesScroll')
  }

  return (
    <section
      className={classes.resourcesContainer}
      onScroll={onScroll}
    >
      <ResponsiveContainer className={classes.responsive}>
        <form
          ref={filterFormRef}
          className={classes.searchContainer}
        >
          <Input
            borderRadius={50}
            className={classes.searchInput}
            name='filter'
            onChange={handleChange}
            onFocus={onFocus}
            placeholder={i18n.t(PLACEHOLDER_RESOURCES_FILTER)}
            value={searchTerm}
          />
          <div className={classes.spacer} />
          <IconInline
            className={classes.searchIcon}
            name={searchTerm.length ? 'close' : 'search'}
            onClick={resetSearch}
            size={searchTerm.length ? 16 : 22}
          />
        </form>
        <ul
          className={classes.list}
          onScroll={onScroll}
        >
          {searchResults.map((resource, index) => (
            <a
              key={index}
              className={classes.link}
              href={url}
              onClick={() => processResourceLink(resource, index)}
              rel='noreferrer noopener'
              target='_blank'
            >
              <li className={classes.listItem}>
                <IconInline
                  name={resource.type}
                  size={26}
                />
                <div className={classes.text}>
                  <Title
                    className={classes.title}
                    color='var(--resource__item__text)'
                    size='sm'
                  >{resource.name}
                  </Title>
                  <Paragraph
                    color='var(--resource__description__text)'
                    size='md'
                  >{resource.description}
                  </Paragraph>
                </div>
              </li>
            </a>
          ))}
        </ul>
        {!searchResults.length && (
          <Title
            className={classes.noResults}
            color='var(--no-results__text)'
            size='sm'
          >{i18n.t(EMPTY_STATE_RESOURCES)}
          </Title>
        )}
      </ResponsiveContainer>
    </section>
  )
}

export default Resources
